import _ from 'lodash';

import splitUrlPiece from './splitUrlPiece';

const splitHashParams = _.partial(splitUrlPiece, '#');

export default splitHashParams;
